// Converted to lazy loading
const salesDiscountsIndex = () => import('@/pages/discounts/salesDiscounts/index.vue')
const salesDiscountsForm = () => import('@/pages/discounts/salesDiscounts/form.vue')
const salesDiscountsShow = () => import('@/pages/discounts/salesDiscounts/show.vue')

const purchaseDiscountsIndex = () => import('@/pages/discounts/purchaseDiscounts/index.vue')
const purchaseDiscountsForm = () => import('@/pages/discounts/purchaseDiscounts/form.vue')
const purchaseDiscountsShow = () => import('@/pages/discounts/purchaseDiscounts/show.vue')

const routes = [
  // customers routes
  {
    path: 'salesDiscounts',
    name: 'salesDiscounts',
    component: salesDiscountsIndex
  },
  {
    path: 'salesDiscounts/create',
    name: 'salesDiscountsCreate',
    component: salesDiscountsForm
  },
  {
    path: 'salesDiscounts/:id/edit',
    name: 'salesDiscountsEdit',
    component: salesDiscountsForm
  },
  {
    path: 'salesDiscounts/:id',
    name: 'salesDiscountsShow',
    component: salesDiscountsShow
  },

  //quotations routs

  {
    path: 'purchaseDiscounts',
    name: 'purchaseDiscounts',
    component: purchaseDiscountsIndex
  },
  {
    path: 'purchaseDiscounts/create',
    name: 'purchaseDiscountsCreate',
    component: purchaseDiscountsForm
  },
  {
    path: 'purchaseDiscounts/:id/edit',
    name: 'purchaseDiscountsEdit',
    component: purchaseDiscountsForm
  },
  {
    path: 'purchaseDiscounts/:id',
    name: 'purchaseDiscountsShow',
    component: purchaseDiscountsShow
  },

  {
    path: 'purchaseDiscounts/create',
    name: 'purchaseDiscountsCreate',
    component: purchaseDiscountsForm
  },
  {
    path: 'purchaseDiscounts/:id/edit',
    name: 'purchaseDiscountsEdit',
    component: purchaseDiscountsForm
  },
  {
    path: 'purchaseDiscounts/:id',
    name: 'purchaseDiscountsShow',
    component: purchaseDiscountsShow
  }
]

export default routes
